module.exports = __webpack_public_path__ + "img/book(7).6e02da16.png";